<template>
  <div class="box-image flex flex-col justify-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BoxImage"
};
</script>

<style lang="scss" scoped>
.box-image {
  height: 7.392rem;
  flex: 0 0 7.392rem;
}

@media (min-height: 1024px) {
  .box-image {
    height: 8.448rem;
    flex: 0 0 8.448rem;
  }
}

@media (max-width: 380px), (max-height: 600px) {
  .box-image {
    height: 5rem;
    flex: 0 0 5rem;
  }
}
</style>
